export enum HandlingState {
    Processing = 1,
    Executed = 2,
    Rejected = 3
}
